export default "__VITE_ASSET__CiFa4q7L__"